module.exports = __webpack_public_path__ + "static/media/Savings.78305723.svg";